import {TurnoRecord} from "@commons/mapping/TurnoRecord";
import {TabellaArrotondamentiRecord} from "@commons/mapping/TabellaArrotondamentiRecord";
import {StatusRecord} from "@commons/mapping/StatusRecord";
import {FlexRecord} from "@commons/mapping/FlexRecord";
import {TolleranzaRecord} from "@commons/mapping/TolleranzaRecord";
import {QuantificaEccRecord} from "@commons/mapping/QuantificaEccRecord";
import {QualificaEccRecord} from "@commons/mapping/QualificaEccRecord";
import {TabellaGiustAutoRecord} from "@commons/mapping/TabellaGiustAutoRecord";
import {FasciaOrariaWeekRecord} from "@commons/mapping/FasciaOrariaWeekRecord";
import {TabellaWFRecord} from "@commons/mapping/TabellaWFRecord";
import {CausaleWFRecord} from "@commons/mapping/CausaleWFRecord";
import {AccumuloRecord} from "@commons/mapping/AccumuloRecord";
import {TerminaleRecord} from "@commons/mapping/TerminaleRecord";
import {CalendarioChiusureRecord} from "@commons/mapping/CalendarioChiusureRecord";
import {GiustificativoRecord, GruppoEventi} from "@commons/mapping/GiustificativoRecord";
import {TabellaAlternativiRecord} from "@commons/mapping/TabellaAlternativiRecord";
import {ValoreAccumuloRecord} from "@commons/mapping/ValoreAccumuloRecord";
import {getValoreAccumuloXDip} from "@commons/services/presenze_api/valoriAccumuli.api";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";

export interface CachePresenze {
    idDominio: number,
    idAziendaTabelle: number,
    idTabellaWF: number,

    turni: TurnoRecord[];
    turniAlternativi: TabellaAlternativiRecord[];
    arrotondamenti: TabellaArrotondamentiRecord[];
    tabelleFlex: FlexRecord[];
    tabelleTolleranza: TolleranzaRecord[];
    tabelleQuantificaEcc: QuantificaEccRecord [];
    tabelleQualificaEcc: QualificaEccRecord[];
    tabelleGiustificazioneAuto: TabellaGiustAutoRecord[];
    tabelleFasceOrarie: FasciaOrariaWeekRecord[];
    tabelleStatus: StatusRecord[]; // [] di CentroDiCosto
    gruppiEventi: GruppoEventi; // object dove ogni proprietà è un [] di object rappresentanti i valori del gruppo corrispondente
    tabellaWF: TabellaWFRecord | null;
    causaliWF: CausaleWFRecord[];
    accumuliCHK: AccumuloRecord[];
    terminali: TerminaleRecord[];
    calendari: CalendarioChiusureRecord[];
    elencoGiustificativi: GiustificativoRecord[];
    elencoUnitaLocali: AziendaRecord[];
}

const showLog = false;
const showError = (error: any) => console.log('ERRORE' + JSON.stringify(error));

export class CachePresenze {
    private stale: boolean;

    constructor(idDominio: number,
                idAziendaTabelle: number,
                idTabellaWF: number) {
        this.idDominio = idDominio;
        this.idAziendaTabelle = idAziendaTabelle;
        this.idTabellaWF = idTabellaWF;
        this.stale = false;
    }

    static setStale(caches: CachePresenze[], idAziendaTabelle?: number) {
        if (caches)
            caches.forEach(cache => {
                if (!idAziendaTabelle || idAziendaTabelle === cache.idAziendaTabelle)
                    cache.stale = true
            });
    }

    public isStale = () => this.stale;

    /**
     * getValoriAccumuli non cerca tra un ipotetica cache i valori degli accumuli richiesti, bensì effettua direttamente la get per ciascun accumulo indicato, valorizzandone il valore ottenuto!
     * N.B. Restituisce una Promise<void>!s
     */
    static getValoriAccumuli = (accumuliANNO: AccumuloRecord[]): Promise<void> => {
        showLog && console.log('getValoriAccumuli INIZIO');
        const setupSaldo = (accumulo: ValoreAccumuloRecord) => {
            // Riconcilio valore su relativo accumulo...
            for (let ind0 = 0; ind0 < accumuliANNO.length; ++ind0) {
                if (accumuliANNO[ind0].id === accumulo.codAccumulo) {
                    accumuliANNO[ind0].saldoIniziale = accumulo.valore;
                    accumuliANNO[ind0].valoreVoce = accumulo.valoreVoce;
                    break;
                }
            }
        };

        return new Promise<void>((resolve, reject) => {

            const gets: Promise<void>[] = [];
            for (let ind0 = 0; ind0 < accumuliANNO.length; ++ind0) {
                gets.push(getValoreAccumuloXDip(accumuliANNO[ind0].params).then(
                    setupSaldo,
                    (error) => {
                        showError(error)
                    }));
            }
            if (gets.length > 0) {
                Promise.all(gets).then(
                    () => {
                        showLog && console.log('getValoriAccumuli FINE');
                        resolve()
                    },
                    (err) => {
                        reject(err)
                    }
                );
            } else {
                resolve();
            }
        });
    };

    public getTurno = (codTurno: number) => {
        for (let ind0 = 0; ind0 < this.turni.length; ++ind0) {
            if (this.turni[ind0].codTurno === codTurno) {
                return this.turni[ind0];
            }
        }
        return null;
    };

    public getTurniAlternativi = (idTabella: number) => {
        for (let ind0 = 0; ind0 < this.turniAlternativi.length; ++ind0) {
            if (this.turniAlternativi[ind0].idTabella === idTabella) {
                return this.turniAlternativi[ind0];
            }
        }
        return null;
    };

    public getTabellaArrotondamenti = (idArrotondamenti: number) => {
        for (let ind0 = 0; ind0 < this.arrotondamenti.length; ++ind0) {
            if (this.arrotondamenti[ind0].idArrotondamenti === idArrotondamenti) {
                return this.arrotondamenti[ind0];
            }
        }
        return null;
    };

    public getTabellaFlex = (idFlex: number) => {
        for (let ind0 = 0; ind0 < this.tabelleFlex.length; ++ind0) {
            if (this.tabelleFlex[ind0].idFlex === idFlex) {
                return this.tabelleFlex[ind0];
            }
        }
        return null;
    };

    public getTabellaTolleranza = (idTolleranza: number) => {
        for (let ind0 = 0; ind0 < this.tabelleTolleranza.length; ++ind0) {
            if (this.tabelleTolleranza[ind0].idTolleranza === idTolleranza) {
                return this.tabelleTolleranza[ind0];
            }
        }
        return null;
    };

    public getTabellaQuantificaEcc = (idTabella: number) => {
        for (let ind0 = 0; ind0 < this.tabelleQuantificaEcc.length; ++ind0) {
            if (this.tabelleQuantificaEcc[ind0].idTabella === idTabella) {
                return this.tabelleQuantificaEcc[ind0];
            }
        }
        return null;
    };

    public getTabellaQualificaEcc = (idTabella: number) => {
        for (let ind0 = 0; ind0 < this.tabelleQualificaEcc.length; ++ind0) {
            if (this.tabelleQualificaEcc[ind0].idTabella === idTabella) {
                return this.tabelleQualificaEcc[ind0];
            }
        }
        return null;
    };

    public getTabellaGiustificazioneAuto = (idTabella: number) => {
        for (let ind0 = 0; ind0 < this.tabelleGiustificazioneAuto.length; ++ind0) {
            if (this.tabelleGiustificazioneAuto[ind0].idTabella === idTabella) {
                return this.tabelleGiustificazioneAuto[ind0];
            }
        }
        return null;
    };

    public getTabellaFasceOrarie = (idFasciaOraria: number) => {
        for (let ind0 = 0; ind0 < this.tabelleFasceOrarie.length; ++ind0) {
            if (this.tabelleFasceOrarie[ind0].idFasciaOraria === idFasciaOraria) {
                return this.tabelleFasceOrarie[ind0];
            }
        }
        return null;
    };

    public getCalendario = (idCalendario: number, anno: number) => {
        for (let ind0 = 0; ind0 < this.calendari.length; ++ind0) {
            if (this.calendari[ind0].idCalendario === idCalendario &&
                this.calendari[ind0].anno &&
                this.calendari[ind0].anno!.anno === anno) {
                return this.calendari[ind0];
            }
        }
        return null;
    };

    public getGiustificativiXStatus = (codStatus: string) => {
        if (this.tabelleStatus)
            for (let ind0 = 0; ind0 < this.tabelleStatus.length; ++ind0) {
                if (this.tabelleStatus[ind0].id === codStatus) {
                    return this.tabelleStatus[ind0];
                }
            }
        return null;
    };

    public getGiustificativo = (codGiu: string) => {
        for (let ind0 = 0; ind0 < this.elencoGiustificativi.length; ++ind0) {
            if (this.elencoGiustificativi[ind0].codGiu === codGiu) {
                return this.elencoGiustificativi[ind0];
            }
        }
        return null;
    };
}